import { VFC } from 'react'
import { toggleShowFacebookLinkingPopup } from 'src/api/user'
import { ButtonLink } from 'src/elements/Link'
import {
  facebookBlueLight,
  truewhite,
  _modalunderline,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { AUTH_FACEBOOK } from 'src/utils/routes'
import styled from 'styled-components'

export const FacebookLinking: VFC<{ onPopup?: boolean }> = ({ onPopup }) => (
  <Layout>
    <Title>Facebook連携</Title>
    <Description>
      Facebookアカウントを連携すると次回ログインからID/パスワードを利用せずFacebookでログインがご利用可能になります。
    </Description>
    <FacebookLink href={AUTH_FACEBOOK}>Facebook連携</FacebookLink>
    {onPopup && (
      <TogglePopupLabel>
        <input
          type="checkbox"
          onChange={({ target: { checked } }) =>
            toggleShowFacebookLinkingPopup(checked)
          }
        />
        次回から表示しない
      </TogglePopupLabel>
    )}
  </Layout>
)

const Layout = styled.div`
  border-radius: 20px;
  background-color: ${truewhite};

  text-align: center;
  line-height: 25px;
  width: 80vw;
  padding: 8vw;
  max-width: 720px;
  > * {
    margin: 20px 0;
  }
  @media screen and (min-width: 1024px) {
    width: 100%;
    line-height: 25px;
    padding: 60px 120px;
  }
`
const Title = styled.p`
  display: inline;
  font-size: 16px;
  font-weight: ${fontWeightBold};
  border-bottom: 2px solid ${_modalunderline};
  padding: 0 1em;
`
const Description = styled.p`
  font-weight: ${fontWeightBold};
`

const FacebookLink = styled(ButtonLink)`
  padding: 6px 40px;
  background: ${facebookBlueLight};
  color: white;
`

const TogglePopupLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin-right: auto;
  margin-left: auto;
  cursor: pointer;
  input {
    margin-right: 8px;
  }
`
